module.exports = __webpack_public_path__ + "img/collaborate_11.ba6569ce.jpg";